import * as yup from 'yup';

/**
 * Validation schema for Oracle Downtime Schedule form
 * Matches backend FluentValidation rules:
 * - DowntimeTypeCdId is required
 * - StartDateTime required, must be on the hour (HH:00:00)
 * - For CREATE mode: StartDateTime must be in the future
 * - For EDIT mode: StartDateTime can be in past if schedule already started
 * - EndDateTime optional, must be on hour if provided, must be after StartDateTime
 */
export const createOracleDowntimeValidationSchema = (mode: 'create' | 'edit') =>
  yup.object().shape({
    type: yup.number().required('Downtime Type is required').typeError('Downtime Type is required'),

    startDateTime: yup
      .date()
      .required('Start Date & Time is required')
      .typeError('Start Date & Time must be a valid date')
      .test('on-the-hour', 'Start Date & Time must be on the hour (e.g., 10:00 AM, 2:00 PM)', (value) => {
        if (!value) return false;
        return value.getMinutes() === 0 && value.getSeconds() === 0 && value.getMilliseconds() === 0;
      })
      .test('in-future', 'Start Date & Time must be in the future', (value) => {
        // Only validate future requirement for CREATE mode
        if (mode === 'edit') return true;
        if (!value) return false;
        const now = new Date();
        return value.getTime() > now.getTime();
      }),

    endDateTime: yup
      .date()
      .nullable()
      .typeError('End Date & Time must be a valid date')
      .test('on-the-hour', 'End Date & Time must be on the hour (e.g., 10:00 AM, 2:00 PM)', (value) => {
        if (!value) return true; // null/undefined is valid
        return value.getMinutes() === 0 && value.getSeconds() === 0 && value.getMilliseconds() === 0;
      })
      .test('after-start', 'End Date & Time must be after Start Date & Time', function (value) {
        if (!value) return true; // null is valid
        const { startDateTime } = this.parent;
        if (!startDateTime) return true; // Can't validate without start date
        return value > startDateTime;
      }),
  });
